$(document).ready(function(){

  // if ($('.pdp_page_slider')?.attr('handle') && $(".variant__input--color-swatch:not(.as-variant-product):checked")?.val()) {
  //   updateVariantGallery({
  //     handle: $('.pdp_page_slider')?.attr('handle'),
  //     altKey: $(".variant__input--color-swatch:not(.as-variant-product):checked")?.val()?.toLowerCase()?.replace(/\s+/g, '-'),
  //     charmProductId: Date.now()
  //   });
  // }
  /* product page custom slider js start */

        // siilar products on pdp page
      $('.customSliderSimiler').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite:false,
        dots: true,
        arrows: true,
        autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow left-arrow-style"></button>',
        nextArrow: '<button class="slide-arrow next-arrow right-arrow-style"></button>', 
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
      });

      $('.customSliderSimiler').on('afterChange', function (event, slick, currentSlide) {
        const prevArrow = $('.prev-arrow');
        const nextArrow = $('.next-arrow');

        // Enable or disable the arrows based on the current slide
        if (currentSlide === 0) {
          prevArrow.attr('disabled', true);
          nextArrow.attr('disabled', false);
        } else if (currentSlide === slick.slideCount - 1) {
          prevArrow.attr('disabled', false);
          nextArrow.attr('disabled', true);
        } else {
          prevArrow.attr('disabled', false);
          nextArrow.attr('disabled', false);
        }
      });

      if ($('.customSliderSimiler').length > 0) {
        $('.grid__item').removeClass('medium-up--one-quarter');   
      }
      // function pdp_slider(){
      // $('.pdp_page_slider').slick({
      //   slidesToShow:1,
      //   slidesToScroll: 1,
      //   infinite: true,
      //   dots:true,
      //   arrows:true,
      //   autoplay: false,
      //   prevArrow: '<button class="slide-arrow prev-arrow left-arrow-style"></button>',
      //   nextArrow: '<button class="slide-arrow next-arrow right-arrow-style"></button>' 
      // });
      // }
      // pdp_slider();

      const targetSelector = '.jdgm-prev-badge__text';

      const observer = new MutationObserver(function (mutations, obs) {
        const badge = $(targetSelector);

        if (badge.length && badge.text().includes('View all reviews')) {
          badge.html(function (_, html) {
            return html.replace(/\((\d+)\)\s*(View all reviews)/, '<span>($1)</span> <span style="text-decoration: underline;padding-left: 7px;">$2</span>');
          });

          obs.disconnect(); // Stop observing once done
        }
      });

      // Start observing body for any added nodes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      function getSizedSrc(src, size = '2048x') {
        return src.replace(/(\.(jpe?g|png|gif|webp))(?:\?.*)?$/i, `_${size}$1`);
      }

      function rebindFancyboxFor(uid, gallerySelector) {
      const selector = `${gallerySelector} .slick-slide:not(.slick-cloned) [data-fancybox="${uid}"]`;

      if (window.Fancybox && typeof Fancybox.bind === 'function') {
        try { Fancybox.close(); } catch (e) {}
        Fancybox.unbind('[data-fancybox]'); // unbind everything to be safe
        Fancybox.bind(selector, {
          Thumbs: { autoStart: true },
          infinite: true
        });
      } else if ($.fancybox) {
        // v3 fallback
        $(selector).fancybox({
          loop: true,
          buttons: ['zoom', 'slideShow', 'thumbs', 'close']
        });
      }
    }


  /**
   * Rebuild the main slider, thumbnails, and Fancybox gallery whenever the variant changes.
   */
    function updateVariantGallery({ handle, altKey, charmProductId }) {
      const gallerySelector = '.pdp_page_slider';
      const thumbsSelector  = '.product__thumbs--scrollerr';

      // UNIQUE group every time
      const galleryUid = `charm-gallery-${charmProductId}-${Date.now()}`;

      let paddingDivisionValue = 100;
      let non_intractive_class = '';
      if (window.currentTemplate == 'product.non-intractive' || window.currentTemplate == 'product.non-interactive-pdp-lofos') {
        paddingDivisionValue = 100;
        non_intractive_class = 'non-intrensic-img-size';
      }

      $.ajax({
        url: `/products/${handle}.json`,
        success: function (result) {
          const wanted = (altKey || '').toLowerCase().replace(/\s+/g, '-');

          const images = (result.product.images || []).filter(image => {
            const alt = (image.alt || '').toLowerCase().trim().replace(/\s+/g, '-');
            return alt && alt.includes(wanted) && !alt.startsWith('non_interactive_');
          });

          const slidesHtml = images.map((image, i) => {
            const aspectRatio = (image.width && image.height) ? (image.width / image.height).toFixed(4) : 1;
            const zoom = getSizedSrc(image.src, '1800x1800');
            const srcset = `
              ${getSizedSrc(image.src, '360x')} 360w, 
              ${getSizedSrc(image.src, '540x')} 540w, 
              ${getSizedSrc(image.src, '720x')} 720w, 
              ${getSizedSrc(image.src, '900x')} 900w, 
              ${getSizedSrc(image.src, '1080x')} 1080w
            `;

            return `
              <div class="product-main-slide secondary-slide" data-index="${i}" div-alt="${image.alt || ''}">
                <div data-product-image-main class="product-image-main">
                  <div class="image-wrap" style="height:0; padding-bottom:${paddingDivisionValue / aspectRatio}%;">
                    <a data-fancybox="${galleryUid}" href="${zoom}">
                      <img
                        class="js-photoswipe__zoom product__photo-zoom photoswipe__image lazyload ${non_intractive_class || ''}"
                        data-photoswipe-src="${zoom}"
                        data-photoswipe-width="${image.width || 990}"
                        data-photoswipe-height="${image.height || 1170}"
                        data-charm-product-id="charm-${charmProductId}"
                        data-index="${i}"
                        ${i === 0
                          ? `src="${getSizedSrc(image.src, '540x')}" loading="eager" fetchpriority="high"`
                          : `data-src="${getSizedSrc(image.src, '360x')}" loading="lazy" fetchpriority="auto"`}
                        data-widths="[360,540,720,900,1080]"
                        data-aspectratio="${aspectRatio}"
                        data-sizes="auto"
                        alt="${image.alt || ''}"
                        srcset="${srcset.trim()}"
                        sizes="380px">
                      <noscript>
                        <img class="lazyloaded" src="${getSizedSrc(image.src, '1400x')}" alt="${image.alt || ''}">
                      </noscript>
                    </a>
                  </div>
                </div>
              </div>
            `;
          }).join('');

          const $gallery = $(gallerySelector);

          if ($gallery.hasClass('slick-initialized')) {
            $gallery.slick('unslick');
          }

          $gallery.html(slidesHtml);

          // Re-init slick
          if (typeof pdp_slider === 'function') {
            pdp_slider();
          } else if ($.fn.slick) {
            $gallery.slick({

              arrows: true,
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              infinite: true,
              prevArrow: '<button class="slide-arrow prev-arrow left-arrow-style"></button>',
              nextArrow: '<button class="slide-arrow next-arrow right-arrow-style"></button>'
            });
          }

          // Build thumbnails
          const thumbsHtml = images.map((image, i) => {
            const w = image.width || 1080;
            const h = image.height || 1080;
            const aspectRatio = (w / h);
            const paddingBottom = (100 / aspectRatio).toFixed(4);
            const srcset = `
              ${getSizedSrc(image.src, '120x')} 120w,
              ${getSizedSrc(image.src, '360x')} 360w,
              ${getSizedSrc(image.src, '540x')} 540w,
              ${getSizedSrc(image.src, '720x')} 720w
            `.trim().replace(/\s+/g, ' ');

            return `
              <div class="product__thumb-item" data-index="${i}">
                <div class="image-wrap" style="height:0; padding-bottom:${paddingBottom}%;">
                  <a href="#" class="product__thumb" data-index="${i}">
                    <img
                      class="animation-delay-${(i + 1) * 3}"
                      loading="lazy"
                      data-src="${getSizedSrc(image.src, '360x')}"
                      data-widths="[120,360,540,720]"
                      data-aspectratio="${aspectRatio.toFixed(6)}"
                      data-sizes="auto"
                      alt="${(image.alt || '').replace(/"/g, '&quot;')}"
                      srcset="${srcset}">
                    <noscript>
                      <img class="lazyloaded"
                          src="${getSizedSrc(image.src, '400x')}"
                          alt="${(image.alt || '').replace(/"/g, '&quot;')}" loading="lazy">
                    </noscript>
                  </a>
                </div>
              </div>
            `;
          }).join('');

          $(thumbsSelector).html(thumbsHtml);
          $('.product__thumb-item').eq(0).addClass('active-thumb');
          rebindFancyboxFor(galleryUid, gallerySelector);
        }
      });
    }

    // -----------------------------
    // Variant click handler
    // -----------------------------
      $('body').on('click', 'fieldset .variant-input[data-index="option1"]:not(.variant-as-product)', function () {
        if ($(this).find('input:checked').length) {
          return;
        }
        var vari_article = $(this).find('label').attr('variant-val').split('_')[0];
        if (typeof customVariantImageTag === 'function') {
          customVariantImageTag();
        }

        $(this)
          .parents('.product-section')
          .find('.accordian_item .second-data-text[label="Article Number "]')
          .text(vari_article);

        let alt = $(this).find('input').val();
        alt = (alt || '').toLowerCase().replace(/\s+/g, '-');

        const $slider = $('.pdp_page_slider');
        const handle = $slider.attr('handle');
        // const charmProductId = $slider.data('charm-product-id');
        const charmProductId = Date.now();

        updateVariantGallery({
          handle,
          altKey: alt,
          charmProductId
        });
      });

      $('.charm-card-image-slick').slick({
          slidesToShow:1,
          slidesToScroll: 1,
          infinite: true,
          dots:true,
          arrows:false,
          autoplay: false,
        });
        $('.slick-cloned [data-fancybox]').each(function() {
        this.removeAttribute('data-fancybox');
      });
      // Function to show/hide the variant tag container based on the metafield value
      function customVariantImageTag() {
        var vari_tag =  $('input[name="Color"]:checked').closest('.variant-input').find('label').attr('data-variant-metafield-tag-value');
        var image_container = document.querySelectorAll('#custom_left_section .pdp-variant-tags .cs-tag-container');
        if (vari_tag && vari_tag.trim() !== "") {
          image_container.forEach(function(container) {
            container.style.display = 'block';
          });
        } else {
          image_container.forEach(function(container) {
            container.style.display = 'none';
          });
        }
      }

      // On page load, call the function to check and display the image container
      $(document).ready(function() {
        customVariantImageTag();
      });

    /* product page custom slider js end */
    
    

    // productpage slider dots js
    // setTimeout(function() {
    //   $('.product__main-photos .flickity-page-dots').show();
    // }, 2500);
    
      // you may also like section on cart drawer js
        // recomented product on cart 
          fetch('/cart?view=recommend', {
                credentials: 'same-origin',
                method: 'GET',
              }).then(function (content) {    
                content.text().then(function (html) {
                if ($(html).find('.section_imges').length > 0) {
                    $('.border_collection_section').show();
                  $('.recommented__product_cart').html(html);
                  }else{
                    $('.border_collection_section').hide();
                  }
                });
              });
      // recomented product on cart end

 
 // read more and read less js of collection description 
      $('.moreless-button').click(function() {
        $('.moretext').toggleClass('addremove');
        if ($('.moreless-button').text() == "Read more") {
          $(this).text("Read less")
           $('.dots').hide();
        } else {
          $(this).text("Read more")
          $('.dots').show();
        }
   
      });
  //switches hide and show on collection page
    $(document).on('click', '.btn-custom.select-switchs', function () {
        const current = this;
        if (!$(current).hasClass('switch-height')) {
          $(current).closest('.grid-product').find('a.product-color-swatch--active').click();
          $(document).one('colorChangeCompleted', function (event, target) {
            $(current).parents('.grid-product').find('.color-switch').toggleClass('switch-height');

            // Toggle plus/minus icons
            $(current).find('.icon-plus').toggle();
            $(current).find('.icon-minus').toggle();
          });
        } else {
          $(current).parents('.grid-product').find('.color-switch').toggleClass('switch-height');
          $(current).find('.icon-plus').toggle();
          $(current).find('.icon-minus').toggle();
        }
    });
  $('body').on('click', '.custom-product-card .btn-custom.select-switchs, .default-prod .btn-custom.select-switchs', function() {
  // Toggle the height class on color-switch
  $(this).parents('.grid-product').find('.color-switch').toggleClass('switch-height');
  
  // Toggle visibility between the plus and minus SVG icons
  $(this).find('.icon-plus').toggle();
  $(this).find('.icon-minus').toggle();
  });


   $('body').on('click','#product-add-to-cart_drawer', function() {
      $(this).parents('.crosscell_items').find('.custom-model-main11').slideToggle(500);
      })

   //collection page slider js
    $('.slider-mobile').slick({
      slidesToShow: 2.1,
      slidesToScroll: 1,
      infinite: true,
      autoplaySpeed: 3000,
      dots:false,
      arrows:false,
      autoplay: true,
      
     });

      
    $(document).ready(function() {
      if (window.currentTemplate == 'product.non-intractive' || window.currentTemplate == 'product.non-interactive-pdp-lofos') {
          $('.prapp-stars').append('<span class="rating-label">View all reviews</span>');
      }
    });


      
  $('body').on('click', '.cstm_collection_add', function (event) {
    event.preventDefault();
    var selectedColor = event.target.closest('.grid-product__content').querySelector('.color-swatch.active');
      let color = document.querySelector('.grid-product__color-image.is-active') || selectedColor;
      let ProductId = $(this).attr('data-id');

      if (color) {
        color = color.getAttribute('data-value').trim().toLowerCase().replace(" ", "-");
        let size = $(this).text().trim(); // Make sure size is trimmed 

        // Get all the option elements from the select dropdown
        const options = this.closest("fieldset").querySelector(`option[data-color-option = '${color}'][data-size-option = '${size}']`);
        ProductId = options.value;
      }
    if ($(this).hasClass('disabled') && $('body[page-type="collection.alternate-collection"]').length) {
      const variantId = ProductId;
      const productId = $(this).data("product-id");
      const productTitle = $(this).data("product-title");
      const productHandle = $(this).data("product-handle");
      const productFeaturedImg = $(this).data("product-featured-img");
      const popupHtml = `<div class="notify__master" style="display:none;" data-variant-id="${variantId}" data-product-id="${productId}" data-product-title="${productTitle}" data-variant-url="/products/${productHandle}?variant=${variantId}">
                          <div id="notify__content" class="popup" >
                            <div class="popup-content">
                              <span class="cross-icon cross-icon_plp" data-variant-id="${variantId}" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                  <circle cx="24" cy="24" r="24" fill="#D9D9D9" fill-opacity="0.25"/>
                                  <path d="M18 18L30 30" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M30 18L18 30" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </span>
                              <span><h2>Out of stock</h2></span>
                              <span>We will notify you once product becomes available.</span>
                              <div class="notify-product-content">
                                <div>
                                  <img
                                    class="notify-me-image-fit"
                                    src="${productFeaturedImg}"
                                    alt="product featured image"
                                    width="100px"
                                    height="100px"
                                  >
                                </div>
                                <div class="notify-popup-product-title">${productTitle}
                                </div>
                              </div>
                            </div>
                            <input
                              type="hidden"
                              name="id"
                              id="variant_id"
                              value= ${variantId}"
                              data-variant-url="/products/${productHandle}?variant=${variantId}"
                              disabled
                            >
                            <label class="mobile-number-label">Enter Mobile Number</label>
                            <div class="notify__text_container">
                              <select name="countryCode" id="countryCode">
                              <option data-countryCode="GB" value="44">UK (+44)</option>
                                <option data-countryCode="US" value="1">USA (+1)</option>
                                <option data-countryCode="DZ" value="213">Algeria (+213)</option>
                                <option data-countryCode="AD" value="376">Andorra (+376)</option>
                                <option data-countryCode="AO" value="244">Angola (+244)</option>
                                <option data-countryCode="AR" value="54">Argentina (+54)</option>
                                <option data-countryCode="AM" value="374">Armenia (+374)</option>
                                <option data-countryCode="AW" value="297">Aruba (+297)</option>
                                <option data-countryCode="AU" value="61">Australia (+61)</option>
                                <option data-countryCode="AT" value="43">Austria (+43)</option>
                                <option data-countryCode="AZ" value="994">Azerbaijan (+994)</option>
                                <option data-countryCode="BS" value="1242">Bahamas (+1242)</option>
                                <option data-countryCode="BH" value="973">Bahrain (+973)</option>
                                <option data-countryCode="BD" value="880">Bangladesh (+880)</option>
                                <option data-countryCode="BB" value="1246">Barbados (+1246)</option>
                                <option data-countryCode="BY" value="375">Belarus (+375)</option>
                                <option data-countryCode="BE" value="32">Belgium (+32)</option>
                                <option data-countryCode="BZ" value="501">Belize (+501)</option>
                                <option data-countryCode="BJ" value="229">Benin (+229)</option>
                                <option data-countryCode="BM" value="1441">Bermuda (+1441)</option>
                                <option data-countryCode="BT" value="975">Bhutan (+975)</option>
                                <option data-countryCode="BO" value="591">Bolivia (+591)</option>
                                <option data-countryCode="BA" value="387">Bosnia Herzegovina (+387)</option>
                                <option data-countryCode="BW" value="267">Botswana (+267)</option>
                                <option data-countryCode="BR" value="55">Brazil (+55)</option>
                                <option data-countryCode="BN" value="673">Brunei (+673)</option>
                                <option data-countryCode="BG" value="359">Bulgaria (+359)</option>
                                <option data-countryCode="BF" value="226">Burkina Faso (+226)</option>
                                <option data-countryCode="BI" value="257">Burundi (+257)</option>
                                <option data-countryCode="KH" value="855">Cambodia (+855)</option>
                                <option data-countryCode="CM" value="237">Cameroon (+237)</option>
                                <option data-countryCode="CA" value="1">Canada (+1)</option>
                                <option data-countryCode="CV" value="238">Cape Verde Islands (+238)</option>
                                <option data-countryCode="KY" value="1345">Cayman Islands (+1345)</option>
                                <option data-countryCode="CF" value="236">Central African Republic (+236)</option>
                                <option data-countryCode="CL" value="56">Chile (+56)</option>
                                <option data-countryCode="CN" value="86">China (+86)</option>
                                <option data-countryCode="CO" value="57">Colombia (+57)</option>
                                <option data-countryCode="KM" value="269">Comoros (+269)</option>
                                <option data-countryCode="CG" value="242">Congo (+242)</option>
                                <option data-countryCode="CK" value="682">Cook Islands (+682)</option>
                                <option data-countryCode="CR" value="506">Costa Rica (+506)</option>
                                <option data-countryCode="HR" value="385">Croatia (+385)</option>
                                <option data-countryCode="CU" value="53">Cuba (+53)</option>
                                <option data-countryCode="CY" value="90392">Cyprus North (+90392)</option>
                                <option data-countryCode="CY" value="357">Cyprus South (+357)</option>
                                <option data-countryCode="CZ" value="42">Czech Republic (+42)</option>
                                <option data-countryCode="DK" value="45">Denmark (+45)</option>
                                <option data-countryCode="DJ" value="253">Djibouti (+253)</option>
                                <option data-countryCode="DM" value="1809">Dominica (+1809)</option>
                                <option data-countryCode="DO" value="1809">Dominican Republic (+1809)</option>
                                <option data-countryCode="EC" value="593">Ecuador (+593)</option>
                                <option data-countryCode="EG" value="20">Egypt (+20)</option>
                                <option data-countryCode="SV" value="503">El Salvador (+503)</option>
                                <option data-countryCode="GQ" value="240">Equatorial Guinea (+240)</option>
                                <option data-countryCode="ER" value="291">Eritrea (+291)</option>
                                <option data-countryCode="EE" value="372">Estonia (+372)</option>
                                <option data-countryCode="ET" value="251">Ethiopia (+251)</option>
                                <option data-countryCode="FK" value="500">Falkland Islands (+500)</option>
                                <option data-countryCode="FO" value="298">Faroe Islands (+298)</option>
                                <option data-countryCode="FJ" value="679">Fiji (+679)</option>
                                <option data-countryCode="FI" value="358">Finland (+358)</option>
                                <option data-countryCode="FR" value="33">France (+33)</option>
                                <option data-countryCode="GF" value="594">French Guiana (+594)</option>
                                <option data-countryCode="PF" value="689">French Polynesia (+689)</option>
                                <option data-countryCode="GA" value="241">Gabon (+241)</option>
                                <option data-countryCode="GM" value="220">Gambia (+220)</option>
                                <option data-countryCode="GE" value="7880">Georgia (+7880)</option>
                                <option data-countryCode="DE" value="49">Germany (+49)</option>
                                <option data-countryCode="GH" value="233">Ghana (+233)</option>
                                <option data-countryCode="GI" value="350">Gibraltar (+350)</option>
                                <option data-countryCode="GR" value="30">Greece (+30)</option>
                                <option data-countryCode="GL" value="299">Greenland (+299)</option>
                                <option data-countryCode="GD" value="1473">Grenada (+1473)</option>
                                <option data-countryCode="GP" value="590">Guadeloupe (+590)</option>
                                <option data-countryCode="GU" value="671">Guam (+671)</option>
                                <option data-countryCode="GT" value="502">Guatemala (+502)</option>
                                <option data-countryCode="GN" value="224">Guinea (+224)</option>
                                <option data-countryCode="GW" value="245">Guinea - Bissau (+245)</option>
                                <option data-countryCode="GY" value="592">Guyana (+592)</option>
                                <option data-countryCode="HT" value="509">Haiti (+509)</option>
                                <option data-countryCode="HN" value="504">Honduras (+504)</option>
                                <option data-countryCode="HK" value="852">Hong Kong (+852)</option>
                                <option data-countryCode="HU" value="36">Hungary (+36)</option>
                                <option data-countryCode="IS" value="354">Iceland (+354)</option>
                                <option data-countryCode="IN" value="91" selected="selected">India (+91)</option>
                                <option data-countryCode="ID" value="62">Indonesia (+62)</option>
                                <option data-countryCode="IR" value="98">Iran (+98)</option>
                                <option data-countryCode="IQ" value="964">Iraq (+964)</option>
                                <option data-countryCode="IE" value="353">Ireland (+353)</option>
                                <option data-countryCode="IL" value="972">Israel (+972)</option>
                                <option data-countryCode="IT" value="39">Italy (+39)</option>
                                <option data-countryCode="JM" value="1876">Jamaica (+1876)</option>
                                <option data-countryCode="JP" value="81">Japan (+81)</option>
                                <option data-countryCode="JO" value="962">Jordan (+962)</option>
                                <option data-countryCode="KZ" value="7">Kazakhstan (+7)</option>
                                <option data-countryCode="KE" value="254">Kenya (+254)</option>
                                <option data-countryCode="KI" value="686">Kiribati (+686)</option>
                                <option data-countryCode="KP" value="850">Korea North (+850)</option>
                                <option data-countryCode="KR" value="82">Korea South (+82)</option>
                                <option data-countryCode="KW" value="965">Kuwait (+965)</option>
                                <option data-countryCode="KG" value="996">Kyrgyzstan (+996)</option>
                                <option data-countryCode="LA" value="856">Laos (+856)</option>
                                <option data-countryCode="LV" value="371">Latvia (+371)</option>
                                <option data-countryCode="LB" value="961">Lebanon (+961)</option>
                                <option data-countryCode="LS" value="266">Lesotho (+266)</option>
                                <option data-countryCode="LR" value="231">Liberia (+231)</option>
                                <option data-countryCode="LY" value="218">Libya (+218)</option>
                                <option data-countryCode="LI" value="417">Liechtenstein (+417)</option>
                                <option data-countryCode="LT" value="370">Lithuania (+370)</option>
                                <option data-countryCode="LU" value="352">Luxembourg (+352)</option>
                                <option data-countryCode="MO" value="853">Macao (+853)</option>
                                <option data-countryCode="MK" value="389">Macedonia (+389)</option>
                                <option data-countryCode="MG" value="261">Madagascar (+261)</option>
                                <option data-countryCode="MW" value="265">Malawi (+265)</option>
                                <option data-countryCode="MY" value="60">Malaysia (+60)</option>
                                <option data-countryCode="MV" value="960">Maldives (+960)</option>
                                <option data-countryCode="ML" value="223">Mali (+223)</option>
                                <option data-countryCode="MT" value="356">Malta (+356)</option>
                                <option data-countryCode="MH" value="692">Marshall Islands (+692)</option>
                                <option data-countryCode="MQ" value="596">Martinique (+596)</option>
                                <option data-countryCode="MR" value="222">Mauritania (+222)</option>
                                <option data-countryCode="YT" value="269">Mayotte (+269)</option>
                                <option data-countryCode="MX" value="52">Mexico (+52)</option>
                                <option data-countryCode="FM" value="691">Micronesia (+691)</option>
                                <option data-countryCode="MD" value="373">Moldova (+373)</option>
                                <option data-countryCode="MC" value="377">Monaco (+377)</option>
                                <option data-countryCode="MN" value="976">Mongolia (+976)</option>
                                <option data-countryCode="MS" value="1664">Montserrat (+1664)</option>
                                <option data-countryCode="MA" value="212">Morocco (+212)</option>
                                <option data-countryCode="MZ" value="258">Mozambique (+258)</option>
                                <option data-countryCode="MN" value="95">Myanmar (+95)</option>
                                <option data-countryCode="NA" value="264">Namibia (+264)</option>
                                <option data-countryCode="NR" value="674">Nauru (+674)</option>
                                <option data-countryCode="NP" value="977">Nepal (+977)</option>
                                <option data-countryCode="NL" value="31">Netherlands (+31)</option>
                                <option data-countryCode="NC" value="687">New Caledonia (+687)</option>
                                <option data-countryCode="NZ" value="64">New Zealand (+64)</option>
                                <option data-countryCode="NI" value="505">Nicaragua (+505)</option>
                                <option data-countryCode="NE" value="227">Niger (+227)</option>
                                <option data-countryCode="NG" value="234">Nigeria (+234)</option>
                                <option data-countryCode="NU" value="683">Niue (+683)</option>
                                <option data-countryCode="NF" value="672">Norfolk Islands (+672)</option>
                                <option data-countryCode="NP" value="670">Northern Marianas (+670)</option>
                                <option data-countryCode="NO" value="47">Norway (+47)</option>
                                <option data-countryCode="OM" value="968">Oman (+968)</option>
                                <option data-countryCode="PW" value="680">Palau (+680)</option>
                                <option data-countryCode="PA" value="507">Panama (+507)</option>
                                <option data-countryCode="PG" value="675">Papua New Guinea (+675)</option>
                                <option data-countryCode="PY" value="595">Paraguay (+595)</option>
                                <option data-countryCode="PE" value="51">Peru (+51)</option>
                                <option data-countryCode="PH" value="63">Philippines (+63)</option>
                                <option data-countryCode="PL" value="48">Poland (+48)</option>
                                <option data-countryCode="PT" value="351">Portugal (+351)</option>
                                <option data-countryCode="PR" value="1787">Puerto Rico (+1787)</option>
                                <option data-countryCode="QA" value="974">Qatar (+974)</option>
                                <option data-countryCode="RE" value="262">Reunion (+262)</option>
                                <option data-countryCode="RO" value="40">Romania (+40)</option>
                                <option data-countryCode="RU" value="7">Russia (+7)</option>
                                <option data-countryCode="RW" value="250">Rwanda (+250)</option>
                                <option data-countryCode="SM" value="378">San Marino (+378)</option>
                                <option data-countryCode="ST" value="239">Sao Tome &amp; Principe (+239)</option>
                                <option data-countryCode="SA" value="966">Saudi Arabia (+966)</option>
                                <option data-countryCode="SN" value="221">Senegal (+221)</option>
                                <option data-countryCode="CS" value="381">Serbia (+381)</option>
                                <option data-countryCode="SC" value="248">Seychelles (+248)</option>
                                <option data-countryCode="SL" value="232">Sierra Leone (+232)</option>
                                <option data-countryCode="SG" value="65">Singapore (+65)</option>
                                <option data-countryCode="SK" value="421">Slovak Republic (+421)</option>
                                <option data-countryCode="SI" value="386">Slovenia (+386)</option>
                                <option data-countryCode="SB" value="677">Solomon Islands (+677)</option>
                                <option data-countryCode="SO" value="252">Somalia (+252)</option>
                                <option data-countryCode="ZA" value="27">South Africa (+27)</option>
                                <option data-countryCode="ES" value="34">Spain (+34)</option>
                                <option data-countryCode="LK" value="94">Sri Lanka (+94)</option>
                                <option data-countryCode="SH" value="290">St. Helena (+290)</option>
                                <option data-countryCode="KN" value="1869">St. Kitts (+1869)</option>
                                <option data-countryCode="SC" value="1758">St. Lucia (+1758)</option>
                                <option data-countryCode="SD" value="249">Sudan (+249)</option>
                                <option data-countryCode="SR" value="597">Suriname (+597)</option>
                                <option data-countryCode="SZ" value="268">Swaziland (+268)</option>
                                <option data-countryCode="SE" value="46">Sweden (+46)</option>
                                <option data-countryCode="CH" value="41">Switzerland (+41)</option>
                                <option data-countryCode="SI" value="963">Syria (+963)</option>
                                <option data-countryCode="TW" value="886">Taiwan (+886)</option>
                                <option data-countryCode="TJ" value="7">Tajikstan (+7)</option>
                                <option data-countryCode="TH" value="66">Thailand (+66)</option>
                                <option data-countryCode="TG" value="228">Togo (+228)</option>
                                <option data-countryCode="TO" value="676">Tonga (+676)</option>
                                <option data-countryCode="TT" value="1868">Trinidad &amp; Tobago (+1868)</option>
                                <option data-countryCode="TN" value="216">Tunisia (+216)</option>
                                <option data-countryCode="TR" value="90">Turkey (+90)</option>
                                <option data-countryCode="TM" value="7">Turkmenistan (+7)</option>
                                <option data-countryCode="TM" value="993">Turkmenistan (+993)</option>
                                <option data-countryCode="TC" value="1649">Turks &amp; Caicos Islands (+1649)</option>
                                <option data-countryCode="TV" value="688">Tuvalu (+688)</option>
                                <option data-countryCode="UG" value="256">Uganda (+256)</option>
                                <option data-countryCode="GB" value="44">UK (+44)</option>
                                <option data-countryCode="UA" value="380">Ukraine (+380)</option>
                                <option data-countryCode="AE" value="971">United Arab Emirates (+971)</option>
                                <option data-countryCode="UY" value="598">Uruguay (+598)</option>
                                <option data-countryCode="US" value="1">USA (+1)</option>
                                <option data-countryCode="UZ" value="7">Uzbekistan (+7)</option>
                                <option data-countryCode="VU" value="678">Vanuatu (+678)</option>
                                <option data-countryCode="VA" value="379">Vatican City (+379)</option>
                                <option data-countryCode="VE" value="58">Venezuela (+58)</option>
                                <option data-countryCode="VN" value="84">Vietnam (+84)</option>
                                <option data-countryCode="VG" value="84">Virgin Islands - British (+1284)</option>
                                <option data-countryCode="VI" value="84">Virgin Islands - US (+1340)</option>
                                <option data-countryCode="WF" value="681">Wallis &amp; Futuna (+681)</option>
                                <option data-countryCode="YE" value="969">Yemen (North)(+969)</option>
                                <option data-countryCode="YE" value="967">Yemen (South)(+967)</option>
                                <option data-countryCode="ZM" value="260">Zambia (+260)</option>
                                <option data-countryCode="ZW" value="263">Zimbabwe (+263)</option>
                              </select>
                              <input
                                type="tel"   
                                id="notify__text" 
                                maxlength="10"
                                class="notify-text"
                                data-productId="${productId}"
                                data-variantId="${variantId}"
                                data-productTitle="${productTitle}"
                                placeholder="Type Here"
                                oninput="validatePhoneNumber(this)"
                              >  
                            </div>
                            <div id="error-message" class="input-error-msg">Please enter a valid 10-digit mobile number.</div>  
                            <div>
                              <input
                                type="button"
                                name="notify"
                                class="btn shopify-payment-button__button shopify-payment-button__button--unbranded"
                                id="notify__button"
                                value="Remind me"
                                onclick=" notifyOnWhatsAppPLP(this) "
                                data-variant-url="/products/${productHandle}?variant=${variantId}"
                                data-variant-id="${variantId}"
                              >
                            </div> 
                          </div>
                        </div>`
                        $(this).after(popupHtml);
                        const $popup = $(".notify__master");
                        $popup.css("display", "block");
                        $('body').addClass('overflow-hidden');
    } 
    else {
      var vdata = { quantity: 1, id: ProductId };

      // Add to cart
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: vdata,
        dataType: 'json',
        success: function (cart) {
          $.getJSON('/cart.json', function (data) {
            var item_count = data.item_count;
            $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
          });
          var cart = new theme.CartDrawer;
          cart.init();
          cart.open();
        },
        error: function () {
          alert('This combination of variant is not available please try different variants.');
        }
      });
      // End add to cart
    }
  });

//review-testimonial

      $(document).on('click', '.cross-icon_plp', function () {
        const variantId = $(this).attr('data-variant-id');
        const $popup = $(`.notify__master[data-variant-id="${variantId}"]`);
        if ($popup.length) {
        $popup.fadeOut(200, function () {
            $(this).remove(); 
          });
          $popup.find('#notify__text').val('');
          $popup.find('#error-message').hide();
          $('body').removeClass('overflow-hidden'); // Re-enable scroll
        }
      });
  
    // Initial Slick slider setup
      function initializeSlick(slickClass) {
        const sliders = document.querySelectorAll(`.${slickClass}`);
        
        sliders.forEach(slider => {
          if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
          }

          // Reinitialize Slick
          $(slider).slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            arrows: false,
            autoplay: false
          });
        });
      }

  initializeSlick("custom_slider-mobile");
  initializeSlick("custom-image-element-wrap");


    // Function to set width and refresh Slick slider
    function setWidthAndRefreshSlider(width) {
      const containers = document.querySelectorAll('.collection-content-main-container .small--one-half');
      containers.forEach(container => {
          container.style.width = width;
      });

      setTimeout(() => {
          const sliders = document.querySelectorAll('.custom_slider-mobile');
          sliders.forEach(slider => {
              $(slider).slick('setPosition');  
          });
      }, 50);
    }

    // Click event for the 100% width icon
    const oneIcon = document.getElementById('grid-one-view');
    if (oneIcon) { 
      oneIcon?.addEventListener('click', () => { 
          setWidthAndRefreshSlider('100%'); 
          initializeSlick("custom-image-element-wrap");
      });
    }

    // Click event for the #list-view icon: 100% on mobile, 50% on desktop
    const twoIcon = document.getElementById('list-view');
    if (twoIcon) {
      twoIcon?.addEventListener('click', () => {
          const isMobile = window.innerWidth <= 768;  
          setWidthAndRefreshSlider(isMobile ? '100%' : '50%');
      });
    }

    // Click event for the #grid-view icon: 50% only on mobile
    const threeIcon = document.getElementById('grid-view');
    if (threeIcon) {
      threeIcon?.addEventListener('click', () => {
          const isMobile = window.innerWidth <= 768;  
          initializeSlick("custom-image-element-wrap");
          if (isMobile) {
              setWidthAndRefreshSlider('50%');  
          }
      });
    }

    // 100% width is applied initially if #grid-one-view is active on page load
    if (oneIcon && oneIcon.classList.contains('active')) {
      setWidthAndRefreshSlider('100%');
    }
 
  // review form show and hide js
  $('.writeReview').click(function(){
   $('.review-form').toggleClass('review-form-show');
    if($('.review-form').hasClass("review-form-show")){
      $('.btn.writeReview').text('Close Review');
    }else{
      $('.btn.writeReview').text('Write Review');
    }
  })

    //   /***************************sticky atc button product page *************************/
    //        $(window).scroll(function(){
    //          if($(window).width() < 718){
    //             if ($(window).scrollTop() > 850 ) {
    //               $(".button-container").addClass('visible');
    //               $(".scrollup").show();
    //             }
    //             else{
    //               $(".scrollup").hide();
    //             }  
    //           }
    //         });
    //  /*************************** end sticky atc button product page *************************/
      /***************************sticky atc button product page *************************/
      $(window).scroll(function(){
        if($(window).width() < 718){
          // if ($(window).scrollTop() > 1510 ) {
            $(".sticky-atc-btn-product").show();
            $(".scrollup").show();

          // }
          // else{
          //   $(".sticky-atc-btn-product").hide();
          //   $(".scrollup").hide();
          // }  
      }
      });
   /*************************** end sticky atc button product page *************************/

   /***************************clivk sticky atc button show varians  *************************/
   $('body').on('click','.show-varient',function(){
    // $(".custom-model-main").addClass('model-open');
      var container = $('.template-product');
             var scrollTo = $('.product-single__form');
             var position = scrollTo.offset().top
				- container.offset().top
				+ container.scrollTop()-120;
      $('body#news,html').animate({scrollTop:position}, 600);
   })

    // $('.bg-overlay').click(function(){
    //    $(".custom-model-main").removeClass('model-open');
    // })


      $('.sticky-add-button').click(function(){
      var productVID = $(this).attr('dataV-id');
      var vidata = {quantity:1,id:productVID};
        // add to cart
      jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: vidata,
              dataType: 'json',
              success: function(cart)
          {
            $.getJSON('/cart.json', function(data){
            var item_count = data.item_count;
              $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
            });
          $('.custom-model-main').removeClass('model-open');
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
              }
            });
        // End add to cart
      })

      $('body').on('click','.addSingleProduct',function(){
      var productVID = $(this).attr('dataV-id-cart');
      var vidata = {quantity:1,id:productVID};
        // add to cart
      jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: vidata,
              dataType: 'json',
              success: function(cart)
          {
            $.getJSON('/cart.json', function(data){
            var item_count = data.item_count;
              $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
            });
          $('.custom-model-main').removeClass('model-open');
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
              }
            });
        // End add to cart
      })

      $('body').on('click','.withoutSIzeVariants',function(){
      var productVID = $(this).attr('vid-product-id');
      var vidata = {quantity:1,id:productVID};
        // add to cart
      jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: vidata,
              dataType: 'json',
              success: function(cart)
          {
            $.getJSON('/cart.json', function(data){
            var item_count = data.item_count;
              $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
            });
          $('.custom-model-main').removeClass('model-open');
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
              }
            });
        // End add to cart
      })
      
        $('body').on('click','#product-add-to-cart_drawer',function(){
          // $(this).parents('.crosscell_items').find('.custom-model-main').show();
        })
      

 
      // ------------------VIEW MORE IN ACCORD-------------------

      $('.legal_details').click(function () {
        $('.view_legal_details').toggle();
      });

  
 
})
// Variant change main image for non-intractive theme
$(document).ready(function(){
  $('.product__thumb-item').eq(0).addClass('active-thumb');
  $(".review-filter-btn").eq(0).addClass("active");
});
    $(document).on('click', '.product__thumb-item', function () {
  
     $('.product__thumb-item').removeClass('active-thumb');
      $(this).addClass('active-thumb');
      var thumbIndex = parseInt($(this).data('index'), 10); 
  
      var $slides = $('.inner_product_slider .product-main-slide:not(.slick-cloned)');
      var slideToGo = -1;
  
      $slides.each(function (i) {
        var slideIndex = parseInt($(this).data('index'), 10);
        if (slideIndex === thumbIndex) {
          slideToGo = i; 
          return false;  
        }
      });
  
      if (slideToGo >= 0) {
        $('.inner_product_slider').slick('slickGoTo', slideToGo);
      }
    });
$('.inner_product_slider').on('afterChange', function(event, slick, currentSlide){
  var $currentSlide = $(slick.$slides.get(currentSlide));
  var currentIndex = parseInt($currentSlide.data('index'), 10);

  $('.product__thumb-item').removeClass('active-thumb');

  $('.product__thumb-item').each(function () {
    var thumbIndex = parseInt($(this).data('index'), 10);
    if (thumbIndex === currentIndex) {
      $(this).addClass('active-thumb');
      return false; 
    }
  });
});


$(document).on('click', '.review_tag', function () {
  var clickedText = $(this).text().trim();
  var $targetSection = $('#review-section');
 $(".review_tag").removeClass("active");
  $(this).addClass("active");
  if ($targetSection.length === 0) {
    console.warn('Review section not found.');
    return;
  }

  // Scroll to the section
  $('html, body').animate({
    scrollTop: $targetSection.offset().top - 100 // adjust offset if you have sticky header
  }, 500, function () {
    // After scrolling, find the matching button and click it
    var $matchingBtn = $targetSection.find('.review-filter-btn').filter(function () {
      return $(this).text().trim() === clickedText;
    });

    if ($matchingBtn.length) {
      $('.review-filter-btn').removeClass('active'); // optional: clear previous selection
      $matchingBtn.addClass('active').trigger('click'); // click the button
    } else {
      console.warn('No matching filter button found for: ' + clickedText);
    }
  });
});




$(document).on('click', '.review-filter-btn', function () {
  var clickedText = $(this).text().trim();
 $(".review_tag").removeClass("active");
    // After scrolling, find the matching button and click it
    var $matchingBtn = $('.review_tags_wrap').find('.review_tag').filter(function () {
      return $(this).text().trim() === clickedText;
    });

    if ($matchingBtn.length) {
      $('.review_tag').removeClass('active'); // optional: clear previous selection
      $matchingBtn.addClass('active'); // click the button
    } else {
      console.warn('No matching filter button found for: ' + clickedText);
    }
  });


// product-form js
//document.addEventListener("DOMContentLoaded", (event) => {
 document.addEventListener('click', function (e) {
  const acc_heading = e.target.closest('.accordian_heading');
  if (!acc_heading) return;

  const acc_item = acc_heading.closest('.accordian_item');
  const acc_text = acc_heading.nextElementSibling;

  const all_acc_texts = document.querySelectorAll('.accordian_text');
  const all_acc_items = document.querySelectorAll('.accordian_item');

  if (acc_text.style.display === 'block') {
    acc_text.style.display = 'none';
    acc_item.classList.remove('active');
  } else {
    all_acc_texts.forEach(text => text.style.display = 'none');
    all_acc_items.forEach(item => item.classList.remove('active'));

    acc_text.style.display = 'block';
    acc_item.classList.add('active');
  }
});


// lightning deal CountDown
class CountDownPdp extends HTMLElement {
  constructor() {
    super();
    this.initCountDown()
  }
  initCountDown() {
    this.endYear = this.dataset.endyear || 2026;
    this.endMonth = this.dataset.endmonth || 0;
    this.endDay = this.dataset.endday || 1;
    this.endHour = this.dataset.endhour || 0;
    this.endMinute = this.dataset.endminute || 0;
    this.countdownFormat = this.dataset.countdownformat || `Offer ends in {days}days {hours}hrs {minutes}mins {seconds}sec`;

    let countDownDate = new Date(this.endYear, this.endMonth, this.endDay, this.endHour, this.endMinute).getTime();

    // Update the count down every 1 second
    let offerCountDownData = {}

    offerCountDownData.countDownFunction = setInterval(() => {

      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.innerHTML = this.countdownFormat.replace('{days}', days).replace('{hours}', hours).replace('{minutes}', minutes).replace('{seconds}', seconds);
        // If the count down is finished, write some text
      if (distance < 0) {
        this.innerHTML = "FLASHSALE END";
        clearInterval(offerCountDownData.countDownFunction);
        sessionStorage.setItem('flashSaleEnded', 'true');
        flashsalecollection = true;
    
      }
    }, 1000);
  }
}
customElements.define('count-down-pdp', CountDownPdp);

// color variant slider 
  $('.product-color-grid').slick({
    slidesToShow: 6,    // Adjust the number of visible items
    slidesToScroll: 1,  // How many slides to scroll at once
    arrows: true, 
    infinite:false,  
    autoplay: false,      // Show arrows
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5, // Adjust for mobile view
          slidesToScroll: 1, 
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5, // Show 1 item on smaller screens
          slidesToScroll: 1,  
        }
      }
    ]
  });   


 
  $('.main-img-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.thumbs'
  });
  $('.thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-img-wrapper',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });



// Upsell product Charm product Section'd add to cart and buy now function's.
function getSelectedCharms() {
  const selectedCharms = [];
  $('.charm-charm-checkbox:checked').each(function () {
    const $checkbox = $(this);
    selectedCharms.push({
      variantId: parseInt($checkbox.val()),
      productId: $checkbox.data('product-id'),
      title: $checkbox.closest('.charm-product-card').find('.charm-product-title').text().trim()
    });
  });
  return selectedCharms;
}

function buildCartItems(mainVariantId, charms = []) {
  const properties = {};
  charms.forEach((charm, index) => {
    properties[`_CharmProduct${index + 1}`] = `${charm.variantId}/${charm.title} (${charm.productId})`;
  });

  const items = [{
    id: parseInt(mainVariantId),
    quantity: 1,
    properties
  }];

  charms.forEach(charm => {
    items.push({
      id: charm.variantId,
      quantity: 1
    });
  });

  return items;
}

function showToast(message, type = 'info') {
  const toast = document.createElement('div');
  toast.innerText = message;
  toast.style.position = 'fixed';
  toast.style.top = '20px';
  toast.style.left = '50%';
  toast.style.transform = 'translateX(-50%)';
  toast.style.zIndex = '9999';
  toast.style.padding = '12px 20px';
  toast.style.borderRadius = '6px';
  toast.style.fontSize = '12px';
  toast.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  toast.style.color = '#fff';

  switch (type) {
    case 'warning':
      toast.style.background = '#f5a623';
      break;
    case 'error':
      toast.style.background = '#d9534f';
      break;
    default:
      toast.style.background = '#333';
  }

  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), 3000);
}


async function handleAddToCart(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  const data = await res.json();

  if (!res.ok) {
    throw data;
  }

  // Update cart count after successful add
  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const itemCount = cart.item_count;
    const cartBubble = document.querySelector('.cart-link__bubble');
    if (cartBubble) {
      cartBubble.classList.add('cart-link__bubble--visible');
      cartBubble.textContent = itemCount;
    }
  } catch (err) {
    console.warn('Failed to update cart count:', err);
  }

  return data;
}


function handleCartError(data) {
  if (data?.status === 422 && data.message?.includes("maximum quantity")) {
    showToast("Some items are already in your cart at their maximum quantity.", 'warning');
    return true;
  }
  return false;
}

function handleCharmAddToCart(event) {
  event.preventDefault();
  event.stopImmediatePropagation();

  const mainProductId = this.getAttribute('data-current-variant-id');
  if (!mainProductId) return;

  const charms = getSelectedCharms();
  const items = buildCartItems(mainProductId, charms);

  handleAddToCart(items)
    .then(data => {
      if (!handleCartError(data)) {}
    })
    .catch(() =>
      showToast("Something went wrong while adding to cart.", 'error')
    );
}
$(document).on(
  'click',
  '.custom-add-to-cart-with-charm',
  handleCharmAddToCart
);

// Direct – already rendered elements
$('.custom-add-to-cart-with-charm').on(
  'click',
  handleCharmAddToCart
);
// Add to Cart
// $(document).on("click", ".custom-add-to-cart-with-charm", function (event) {
// //$('.custom-add-to-cart-with-charm').on('click', event => {
//   event.preventDefault();
//   event.stopImmediatePropagation();

//   const mainProductId = document.querySelector('.custom-add-to-cart-with-charm')?.getAttribute('data-current-variant-id');
//   if (!mainProductId) return;

//   const charms = getSelectedCharms();
//   const items = buildCartItems(mainProductId, charms);

//   handleAddToCart(items)
//     .then(data => {
//       if (!handleCartError(data)) { }
//     })
//     .catch(() => showToast("Something went wrong while adding to cart.", 'error'));
// });

// Buy Now (GoKwik)
$(document).on("click", ".custom-gok-wik-buy-now", function (e) {
//$('.custom-gok-wik-buy-now').on('click', event => {
  event.preventDefault();
  event.stopImmediatePropagation();

  const mainProductId = document.querySelector('.custom-add-to-cart-with-charm')?.getAttribute('data-current-variant-id');
  if (!mainProductId) return;

  const charms = getSelectedCharms();
  const items = buildCartItems(mainProductId, charms);

  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => handleAddToCart(items))
    .then(data => {
      if (!handleCartError(data)) {
        if (typeof triggerGokwikCustomCheckout === 'function') {
          triggerGokwikCustomCheckout();
        } else {
          console.warn("Gokwik checkout function not found.");
        }
      }
    })
    .catch(() => showToast("Something went wrong during checkout process.", 'error'));
});
// function setEqualHeight(selector) {
//   const elements = document.querySelectorAll(selector);
//   let maxHeight = 0;

//   // Reset height
//   elements.forEach(el => el.style.height = 'auto');

//   // Calculate max height
//   elements.forEach(el => {
//     const height = el.offsetHeight;
//     if (height > maxHeight) {
//       maxHeight = height;
//     }
//   });

//   // Apply max height
//   elements.forEach(el => el.style.height = maxHeight + 'px');
// }
//   setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product__meta');
//   setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product__title');
//   setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product_subtitle');
//   setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product_rating');
// function applyEqualHeights() {
//   setTimeout(function () {
//     setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product__meta');
//     setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product__title');
//     setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product_subtitle');
//     setEqualHeight('#CollectionAjaxContentSimilarProduct .grid-product_rating');
//   }, 1000);
// }

// window.addEventListener('load', applyEqualHeights);
// // window.addEventListener('DOMContentLoaded', applyEqualHeights);
// window.addEventListener('resize', applyEqualHeights);

// // ALSO run after Slick init
// $('.interactive_gallery').on('setPosition', function () {
//   applyEqualHeights();
// });


// FILTER COLLECTION SEARCH BAR

function filterColorOptions(input) {
  const searchTerm = (input?.value || '').trim().toLowerCase();
  const container = input.closest('.filter-group') || input.parentElement;
  const list = container?.querySelectorAll('.tag') || [];
  const noFilter = container?.querySelector('.no_filter_text');

  let anyVisible = false;

  list.forEach(li => {
    const text = (li.querySelector('.tag__text')?.textContent || '').toLowerCase();
    if (searchTerm === '' || text.includes(searchTerm)) {
      li.style.display = '';
      li.classList.remove('hide');
      anyVisible = true;
    } else {
      li.style.display = 'none';
      li.classList.add('hide');
    }
  });

  if (noFilter) {
    noFilter.style.display = anyVisible ? 'none' : 'block';
  }
}



